// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import axios from "axios";
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
import conf from './conf.js'
Vue.prototype.conf = conf;
import "./assets/css/common.css";
import "./assets/css/index.css";
import store from './store/index';
import message from "./store/rese";
import QRCode from "qrcodejs2";
import jquery from "jquery";
Vue.prototype.$ = jquery;
Vue.use(ElementUI);
Vue.prototype.$message = message;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js